import { IParamPagination } from 'app/core/models/api/pagination';

export type IPeopleSelectSection = {
    type: EPeopleType;
    items: IPeopleSelect[];
};

export type IPeopleSelect = {
    id: string;
    fullname: string;
    number: string;
    type: EPeopleType;
    status: number;
    avatarUrl?: string;
    checked?: boolean;
};

export enum EPeopleType {
    CUSTOMER = 'customer',
    EMPLOYEE = 'employee',
    SUPPLIER = 'supplier'
}


export type IGetAllPeopleForSelect = IParamPagination & {
    'locationIds[]': string[];
    'type[]'?: EPeopleType[];
    search?: string;
    employeeDeliveryRoute?: boolean;
    isActive?: boolean;
    'ids[]'?: string[];
}
